'use client';

function getTextNodeHeight(node, isCustom) {
    if (!isCustom) {
        return {
            lineHeight: 0
        };
    }
    if (node.nodeType === Node.TEXT_NODE) {
        var lineHeight = 0;
        if (node.parentElement) {
            var getLineHeight = window.getComputedStyle(node.parentElement)['line-height'];
            lineHeight = parseFloat(getLineHeight);
        }
        return {
            lineHeight: lineHeight
        };
    }
    if (node.childNodes[0]) {
        return getTextNodeHeight(node.childNodes[0], isCustom);
    }
    return {
        lineHeight: 0
    };
}

export { getTextNodeHeight };
//# sourceMappingURL=helpers.js.map
